/** True when settings include non-empty HTML for a public rich-text page (contact / terms). */
export const hasPublicRichText = html => Boolean((html || '').trim());

export const getError = error => {
  return error.response && error.response.data.message
    ? error.response.data.message
    : error.message;
};
export const regexEmail =
  /[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?/;

export const logoutHandler = async ctxDispatch => {
  ctxDispatch({ type: 'USER_SIGNOUT' });
  localStorage.removeItem('userInfo');
  localStorage.removeItem('shippingAddress');
  localStorage.removeItem('paymentMethod');
  window.location.href = '/signin';
};
